






































































































import { Component } from 'vue-property-decorator';
import { Getter } from "vuex-class";
import ScrollButton from "@/components/ScrollButton.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import SummaryGroupFilter from "@/components/Reports/SummaryGroupFilter.vue";
import { GroupItem } from '@/store/reports/types';

@Component({ components: {SummaryGroupFilter, ScrollButton}})
export default class SummaryGroup extends BaseItemsPage<GroupItem> {

  @Getter("summaryGroup") responseItems: any;

  is_show_filter = true;

  currentSort = "date";

  tableFields = this.tableFieldsDefault;

  getData() {
    return this.responseItems?.messages;
  }

  get tableFieldsDefault() {
    return ['date'];
  }

  get totalData() {
    return {...this.responseItems?.messages_summary, date: this.$t('total')}
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }

 }
